// Preserve existing theme object without overwriting
window.theme = window.theme || {};
var theme = window.theme;
function updateVariantThumbnails(productId) {
  window.addEventListener(`theme:product:${productId}:variantChanged`, ({ detail: { variant }}) => {
    if (variant.options.length > 0) {
      let thumbnailAlt = "#" + variant.options[0].split(" ").join("-").toLowerCase();
      document.querySelectorAll('.product-media--thumb')?.forEach(media => {
        if (media.attributes['thumbnail-alt'].value.toLowerCase().includes(thumbnailAlt) || media.attributes['thumbnail-alt'].value.includes("#all")) {
          media.classList.remove("hide")
        }
        else { 
          media.classList.add("hide")
        }
      });
    }
  });
}
/* Gestion du nombre de swatchs (Si product-card afficher 4 max sinon toute la liste) */
  function updateVariantCount() {
  const swatchesContainers = document.querySelectorAll('.swatches--container');

  swatchesContainers.forEach((container) => {
    const parent = container.closest('.product-card--swatches--column-view');
    if (parent) {
      const swatches = container.querySelectorAll('.swatch');
      const limit = 4;

      swatches.forEach((swatch, index) => {
        if (index >= limit) {
          swatch.style.display = 'none';
        }
      });

      const remainingSwatches = container.querySelector('.swatches--remaining');
      if (swatches.length > limit && remainingSwatches) {
        remainingSwatches.classList.remove('hide');
      }
    }
  });
}
async function updateCart(){
  let response = await fetch('/cart?view=ajax-drawer');
  
  const cartHTML = await response.text();
  theme.cart.fetchTotals();
  theme.cart.updateAllHtml({'cart-drawer': cartHTML});
}
async function addWrapToCart(){
  const wrapId = 14799614640453;
  const wrapVariantId = 53692879274309;
  let addToCart = await fetch('/cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      'items': [{
        'id': wrapVariantId,
        'form_type': 'product',
        'utf8': '✓',
        'product-id': wrapId,
        'quantity': 1,
        'section-id': 'product--quick-add--form'
        }]
      })
    });
  await updateCart()
}
document.addEventListener('DOMContentLoaded', () => {
  updateVariantCount();
});
window.addEventListener('theme:search:reloaded', () => {
  updateVariantCount();
});


// Fix Weglot multiple API calls 
(function() {
  // Intercepter et dédupliquer les appels API Weglot
  if (!window.weglotAPIcache) {
    window.weglotAPIcache = {};
    
    // Sauvegarder la fonction fetch originale
    const originalFetch = window.fetch;
    
    // Override fetch pour les appels Weglot
    window.fetch = function(...args) {
      const url = args[0];
      
      // Si c'est un appel API Weglot slugs
      if (typeof url === 'string' && url.includes('weglot.com/api/projects') && url.includes('/slugs')) {
        // Si déjà en cache, retourner le cache
        if (window.weglotAPIcache[url]) {
          console.log('Weglot: Utilisation du cache pour', url);
          return Promise.resolve(window.weglotAPIcache[url].clone());
        }
        
        // Sinon, faire la vraie requête et la mettre en cache
        return originalFetch.apply(this, args).then(response => {
          window.weglotAPIcache[url] = response.clone();
          console.log('Weglot: Mise en cache de', url);
          return response;
        });
      }
      
      // Pour toutes les autres requêtes, comportement normal
      return originalFetch.apply(this, args);
    };
  }
})();

// Gestion de la fermeture de Shopify Inbox sur mobile
(function() {
  let retryCount = 0;
  const maxRetries = 30; // Essayer pendant 15 secondes max

  function initShopifyInboxCloseButton() {
    // Vérifier si on est sur mobile
    if (window.innerWidth > 768) return;

    // Chercher le conteneur Shopify Chat (c'est un custom element, pas une iframe)
    let chatContainer = document.getElementById('shopify-chat');
    
    // Si pas trouvé via l'id, chercher le custom element directement
    if (!chatContainer) {
      chatContainer = document.querySelector('inbox-online-store-chat');
      if (chatContainer) {
        chatContainer = chatContainer.parentElement || chatContainer;
      }
    }

    if (!chatContainer && retryCount < maxRetries) {
      // Réessayer après un délai si le chat n'est pas encore chargé
      retryCount++;
      setTimeout(initShopifyInboxCloseButton, 500);
      return;
    }

    if (!chatContainer) {
      console.log('Shopify Inbox: conteneur de chat non trouvé après', maxRetries, 'tentatives');
      return;
    }

    console.log('Shopify Inbox: conteneur de chat trouvé', chatContainer);

    // Vérifier si les boutons existent déjà
    if (document.getElementById('shopify-inbox-close-btn')) return;

    // Créer le bouton de fermeture
    const closeBtn = document.createElement('div');
    closeBtn.id = 'shopify-inbox-close-btn';
    closeBtn.innerHTML = `
      <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
      </svg>
    `;
    closeBtn.setAttribute('aria-label', 'Fermer le chat');
    closeBtn.setAttribute('role', 'button');
    closeBtn.setAttribute('tabindex', '0');
    // Masquer jusqu'au premier positionnement pour éviter le flash
    closeBtn.style.visibility = 'hidden';

    // Ajouter le bouton au DOM
    document.body.appendChild(closeBtn);

    // --- Ancrage dynamique par rapport au bouton du chat ---
    function getLauncherElement() {
      const inboxEl = document.querySelector('inbox-online-store-chat');
      if (!inboxEl) return null;
      if (inboxEl.shadowRoot) {
        const btn = inboxEl.shadowRoot.querySelector('button, [role="button"]');
        if (btn) return btn;
      }
      return inboxEl;
    }

    function updateClosePosition() {
      const launcher = getLauncherElement();
      if (!launcher) return;
      const rect = launcher.getBoundingClientRect();
      const offsetX = -6; // px, ajustable
      const offsetY = -6; // px, ajustable
      const top = Math.max(0, rect.top + offsetY);
      const left = Math.max(0, rect.left + offsetX);
      closeBtn.style.top = `${top}px`;
      closeBtn.style.left = `${left}px`;
      closeBtn.style.right = '';
      closeBtn.style.bottom = '';
    }

    // Variable pour savoir si l'utilisateur a fermé le chat manuellement
    let userClosedChat = false;

    // Fonction pour vérifier si le chat est ouvert
    function isChatWindowOpen() {
      // Vérifier l'attribut is-open sur le custom element
      const inboxChat = chatContainer.querySelector('inbox-online-store-chat') || 
                        document.querySelector('inbox-online-store-chat');
      if (inboxChat && inboxChat.getAttribute('is-open') === 'true') {
        return true;
      }
      return false;
    }

    // Observer les changements dans le chat pour détecter l'ouverture/fermeture
    const chatObserver = new MutationObserver(() => {
      // Si l'utilisateur a fermé le chat, ne rien faire
      if (userClosedChat) return;
      
      if (isChatWindowOpen()) {
        closeBtn.classList.add('hidden');
        closeBtn.setAttribute('aria-hidden', 'true');
      } else if (chatContainer.style.display !== 'none') {
        closeBtn.classList.remove('hidden');
        closeBtn.setAttribute('aria-hidden', 'false');
      }
      updateClosePosition();
    });

    chatObserver.observe(chatContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['is-open']
    });

    // Vérification initiale de l'état du chat
    if (isChatWindowOpen()) {
      closeBtn.classList.add('hidden');
      closeBtn.setAttribute('aria-hidden', 'true');
    }
    // Positionnement initial et rendre visible
    updateClosePosition();
    closeBtn.style.visibility = 'visible';

    // Gérer le clic sur le bouton de fermeture
    function closeChat() {
      userClosedChat = true; // Marquer que l'utilisateur a fermé le chat
      chatContainer.style.display = 'none';
      closeBtn.classList.add('hidden');
      closeBtn.setAttribute('aria-hidden', 'true');
    }

    // Événements de clic
    closeBtn.addEventListener('click', closeChat);
    closeBtn.addEventListener('keydown', (e) => {
      if (e.key === ' ' || e.key === 'Spacebar') {
        e.preventDefault();
        closeChat();
      }
      if (e.key === 'Enter') {
        e.preventDefault();
        closeChat();
      }
    });

    // Réinitialiser lors du redimensionnement vers desktop
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        // Sur desktop, afficher le chat et masquer le bouton
        chatContainer.style.display = '';
        closeBtn.classList.add('hidden');
        closeBtn.setAttribute('aria-hidden', 'true');
      } else {
        // Sur mobile, afficher le bouton de fermeture
        closeBtn.classList.remove('hidden');
        closeBtn.setAttribute('aria-hidden', 'false');
        updateClosePosition();
      }
    });

    // Repositionner sur scroll et changement d'orientation
    window.addEventListener('scroll', updateClosePosition, { passive: true });
    window.addEventListener('orientationchange', () => setTimeout(updateClosePosition, 50));
  }

  // Initialiser quand le DOM est prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShopifyInboxCloseButton);
  } else {
    initShopifyInboxCloseButton();
  }

  // Écouter aussi les changements dans le DOM au cas où le chat serait chargé plus tard
  const observer = new MutationObserver((mutations) => {
    if (!document.getElementById('shopify-inbox-close-btn') && window.innerWidth <= 768) {
      const hasChat = document.getElementById('shopify-chat') || document.querySelector('inbox-online-store-chat');
      if (hasChat) {
        observer.disconnect();
        initShopifyInboxCloseButton();
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  console.log('Shopify Inbox Close Button: Script chargé et initialisé');
})();

// Masquer le widget de fidélité (Yotpo Loyalty) sur mobile
(function() {
  const selectors = [
    '#loyaltylion-beacon-frame',
    '#yotpo-loyalty-embedded-sdk',
    '#yotpo-loyalty-app',
    '#yotpo-widget-floating-button',
    '.yotpo-widget-floating-button',
    '[id*="yotpo-loyalty"]',
    '[class*="yotpo-loyalty"]'
  ];

  function applyLoyaltyVisibility() {
    const isMobile = window.innerWidth <= 768;
    document.querySelectorAll(selectors.join(',')).forEach(el => {
      if (isMobile) {
        el.dataset._prevDisplay = el.style.display || '';
        el.style.display = 'none';
      } else {
        if (el.dataset._prevDisplay !== undefined) {
          el.style.display = el.dataset._prevDisplay;
          delete el.dataset._prevDisplay;
        } else {
          el.style.removeProperty('display');
        }
      }
    });
  }

  const observer = new MutationObserver(() => applyLoyaltyVisibility());

  function init() {
    applyLoyaltyVisibility();
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.addEventListener('resize', applyLoyaltyVisibility);
  window.addEventListener('orientationchange', () => setTimeout(applyLoyaltyVisibility, 50));
})();